import { type MonetaryValue } from "@digits-graphql/frontend/graphql-public"
import dateTimeHelper from "@digits-shared/helpers/dateTimeHelper"
import numberHelper, { CurrencyStyle } from "@digits-shared/helpers/numberHelper"

/**
 * Format the amount, excluding cents, with the currency symbol shown
 */
export function displayAbbreviatedPrice(monetaryValue: MonetaryValue) {
  return numberHelper.currency(monetaryValue, {
    style: CurrencyStyle.Aggregation,
  })
}

/**
 * Format the amount, including non-zero cents, with the currency symbol shown
 */
export function displayResponsivePrice(monetaryValue: MonetaryValue) {
  const price = numberHelper.currency(monetaryValue, {
    style: CurrencyStyle.Detail,
  })

  return price.endsWith(".00") ? price.slice(0, price.length - 3) : price
}

/**
 * Format the amount, including cents, with the currency symbol shown
 */
export function displayFullPrice(amount: MonetaryValue) {
  return numberHelper.currency(amount, {
    style: CurrencyStyle.Accounting,
  })
}

const SECONDS_PER_DAY = 86_400 // 60 seconds/min * 60 min/hr * 24 hr/day

export function daysUntil(unixTimestamp: number): number {
  const now = dateTimeHelper.unixNowSeconds()
  const remainingSeconds = unixTimestamp - now
  const remainingDays = Math.ceil(remainingSeconds / SECONDS_PER_DAY)
  return remainingDays > 0 ? remainingDays : 0
}

export default {
  daysUntil,
  displayAbbreviatedPrice,
  displayResponsivePrice,
  displayFullPrice,
}
